<template lang="pug">
.v-notifications.notifications
	transition(name="fade")
		transition-group.notifications__container.container(tag="div" name="list-complete")
			.notifications__item.list-complete-item(v-for="item in items" :key="item.notificationId")
				.notification.flc
					.notification__message
						.notification__text {{item.name}} {{item.model}} {{item.notificationText}}
					a.notification__link(v-if="item.pageLink" :href="item.pageLink") {{ item.showBtn }}
					button.notification__btn-close(:type="item.button?.type || 'button'" :aria-label="item.button?.ariaLabel || 'close'" @click="removeNotification(item.notificationId)")
						v-svg-icon.notification__btn-close-icon(:icon="item.button?.icon || 'close'")
</template>
<script>
import controller from '../scripts/controller/controller';
import uniqueId from '../scripts/helpers/uniqueId';

export default {
	data() {
		return {
			items: [],
			notificationTimeout: null
		};
	},

	created() {
		controller.events.on('add-notification', this.createNotification);
	},

	methods: {
		createNotification(data) {
			console.log(data)
			let notificationId = uniqueId('notification_');
			this.items.push({
				'notificationId': notificationId,
				'name': data.name,
				'model': data.model,
				'notificationText': data.notificationText,
				'showBtn': data.showBtn,
				'button': data.button,
				'pageLink': data.pageLink
			});
			this.notificationTimeout = setTimeout(() => {
				this.removeNotification(notificationId);
			}, 3000);
		},

		removeNotification(id) {
			let foundNotificationIndex = this.items.findIndex(item => item.notificationId === id);
			if (foundNotificationIndex > -1) {
				this.items.splice(foundNotificationIndex, 1);
			}
		}
	}
};
</script>